import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { NavComponent } from 'src/app/traits/nav/nav.component';

@Component({
  selector: 'app-migrations',
  templateUrl: './migrations.component.html',
  styleUrls: ['./migrations.component.css']
})
export class MigrationsComponent implements OnInit {
  merchants: any[] = []; upload: any[] = []; bank: any[]=[]; info: any; exps: any[] = []; 
  id:any; user: any; types: any[] = ["Customer","Accounts","Agent","Officer","Group","Payment","Customer/Account"]
  constructor(private api: ApiService, private exp: ExportExcelService, private use: NavComponent) { }

  ngOnInit() {
    // this.user = this.use.active;
    this.init();
    this.getMore();
  }
  
  getMore(limit=50) {
    this.api.get('merchant?limit='+limit).subscribe((data: any) => {
      this.merchants = data.data; //this.response = data; 
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Merchant List Fail', 'Unable to Fetch Merchant List');
    });
  }

  readFile(event) {
    // this.img = event.target.files[0];
    if(event.target.files[0]) {
      this.exp.readExcel(event.target.files[0]);
      setTimeout(() => { 
        // this.upload = this.exp.import
        this.upload = this.formatRead(this.exp.import); 
        // console.info(this.upload);
      }, 3000);
    }else {
      this.use.showMsg('error', 'File Selection', 'Please Select a valid Excel file');
    }
  }

  readBankFile(event) {
    // this.img = event.target.files[0];
    if(event.target.files[0]) {
      this.exp.readExcel(event.target.files[0]);
      setTimeout(() => { 
        // this.bank = this.exp.import
        this.bank = this.formatReadBank(this.exp.import); 
        // console.info(this.bank);
      }, 3000);
    }else {
      this.use.showMsg('error', 'File Selection', 'Please Select a valid Excel file');
    }
  }

  downloadData() {
    this.api.getdata(this.info.url).subscribe((data: any)=> {
      this.exp.exportAsExcelFile(data.result, this.info.name || 'data'); this.upload = data.result;
      this.use.showMsg('success', 'File Downloaded', 'Succesfully Download File');
    });
  }

  uploadData() {
    this.api.post(this.info.url, this.upload).subscribe((data:any)=> {
      
      if(data.data) this.exp.exportAsExcelFile(data.data, 'notuploaded');
      this.use.showMsg('success', 'File Uploaded', 'Succesfully Upload File');
    });
  }

  formatRead(values) {
    const id = 1; this.exps = [];
    values.forEach((e: any) => {
      const ed = e;
      // ed.active = this.info.name == 'Accounts'?  "Active": true;
      if(this.info.url.includes("Accounts")) { ed.type ="Savings"; };
      // ed.type ="Group";
      if(ed.dateofbirth) ed.dateofbirth = new Date(ed.dateofbirth);
      ed.active = true;
      ed.balance = 0;
      // ed.status = "Status";
      ed.merchantid = this.info.merchantid;
      ed.userid = this.use.active.id;
      ed.date = new Date();
      // const bank = this.bank.find(s => s.order_id === ed.CODE);
      
      // if(bank!=null) { 
      //   ed.bank_status_code=bank.status_code; ed.bank_status_message=bank.status_message;
      //   ed.mdate =bank.date;
      //   // ed.STATUS_CODE = 1; ed.STATUS_MESSAGE = "PAID BY CLIENT"
      // } else {
      //   ed.bank_status_code=0; ed.bank_status_message="PENDING";
      //   ed.mdate =ed.DATE;
      // }
      // const charge = this.bank.find(s => s.order_id === ed.TRANID);
      // console.log(charge);
      // if(charge!=null) { 
      //   ed.bank_charge_status_code=charge.status_code; 
      //   ed.bank_charge_status_message=charge.status_message;
      //   // ed.STATUS_CODE = 1; ed.STATUS_MESSAGE = "PAID BY CLIENT"
      // } else {
      //   ed.bank_charge_status_code=0; ed.bank_charge_status_message="PENDING";
      //   ed.mdate =ed.DATE;
      // }
      // ed.maritalstatus = "N/A";
      // ed.withdrawal = true;
      // ed.approval = true;
      // ed.active = true;
      ed.purpose = "Digital Banking";
      ed.status = "ACTIVE";
      // ed.date = new Date("2021-07-01T00:24:00");
      // const ed = {
      //   CODE: e.CODE || null, FULLNAME: e.FULLNAME, MOBILE: e.MOBILE,
      //   EMAIL: e.EMAIL, DATEOFBIRTH: e.DATEOFBIRTH, 
      //   GENDER: e.GENDER, OCCUPATION: e.OCCUPATION, MARITAL: e.MARITAL, WEDDINGDATE: e.WEDDINGDATE,
      //   GROUP: e.GROUP, DEPARTMENT: e.DEPARTMENT, NOTE: e.NOTE || null, // +', '+e.EMERGENCY_NAME+':- '+ e.EMERGENCY_CONTACT,
      //   Address: e.ADDRESS, STATUS: e.STATUS, DATE: e.JOINDATE
      // };
      this.exps.push(ed); this.id++;
    });
    return this.exps;
  }

  formatReadBank(values) {
    const id = 1; this.exps = [];
    values.forEach((e: any) => {
      const ed = e;
      this.exps.push(ed); this.id++;
    });
    return this.exps;
  }

  init() {
    this.info = { url: '', name: '', merchantid: this.use.active.merchantid };
  }

}
